import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ThingShadowState } from '@iotv/datamodel';
import { CardHeader, Grid, Typography } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import React, { useEffect } from 'react';
import { indexKeyToTypeAndId, isDeviceEnabledType, isLocatable } from '../../data/TypeHelpers';
import { getImageUrl } from '../../data/aws/s3/UserBlobs';
import NavLink from '../navigation/NavLink';
import { NavSections } from '../navigation/NavSections';
const debug = process.env.REACT_APP_DEBUG && false;
export default function ObjectListItem(props) {
    debug && console.log('Object card got props', props);
    const classes = {};
    const viewObject = props.viewObject;
    const [imageUrl, setImageUrl] = React.useState(undefined);
    useEffect(() => {
        async function effectUrl() {
            const objectOrString = await getImageUrl(props.viewObject?.matchedPrimary);
            if (typeof objectOrString === 'string') {
                const url = objectOrString;
                debug && console.log('Use Effect has url', url);
                setImageUrl(url);
            }
            else {
                setImageUrl('');
            }
        }
        effectUrl();
    }, [props.viewObject?.matchedPrimary]);
    // const locatableAddress = getLocatableAddress(viewObject.matchedPrimary)
    // const thing: ValidBusinessObject = viewObject.matchedPrimary ?? ({} as ValidBusinessObject)
    // const { coordinates, location, position } = thing
    const thingShadowStates = viewObject?.matchedRelatedBySk
        ? viewObject?.matchedRelatedBySk
            .filter((item) => item.type === 'ThingShadowState')
            .map((item) => new ThingShadowState(item))
        : [];
    thingShadowStates.sort((tss1, tss2) => {
        const sortRes = tss1?.payload?.timestamp?.toString() && tss2?.payload?.timestamp?.toString()
            ? tss1?.payload?.timestamp?.toString() < tss2.payload?.timestamp?.toString()
                ? 1
                : -1
            : 0;
        return sortRes;
    });
    // const lastestThingStateShadow = thingShadowStates[0]
    // const lastestThingStateShadowOb = lastestThingStateShadow ? new ThingShadowState(lastestThingStateShadow as ValidBusinessObject) : undefined
    // const latestPosition = lastestThingStateShadowOb?.payload?.state?.reported?.position ?? lastestThingStateShadowOb?.state?.reported?.position ?? coordinates ?? location ?? position
    const skAsTypeId = viewObject.matchedPrimary && indexKeyToTypeAndId(viewObject.matchedPrimary.sk);
    return viewObject.matchedPrimary ? (_jsx(NavLink, { filter: `${NavSections.THINGVIEW}/${skAsTypeId?.type}/${skAsTypeId?.id}`, children: _jsx(Card, { className: classes.listCard, children: _jsx(CardContent, { children: _jsxs(Grid, { container: true, spacing: 1, children: [_jsx(Grid, { size: { xs: 4, lg: 4 }, children: _jsxs(Card, { className: classes.variableHeightCard, children: [_jsx(CardHeader, { title: viewObject.matchedPrimary.name }), _jsx(CardContent, { children: imageUrl && _jsx(Avatar, { className: classes.avatar, alt: viewObject.matchedPrimary.name, src: imageUrl }) })] }) }), (isDeviceEnabledType(viewObject.matchedPrimary) || isLocatable(viewObject.matchedPrimary)) && (_jsx(Grid, { size: { xs: 0, lg: 4 }, children: _jsx(Card, { className: classes.variableHeightCard, children: _jsx(CardContent, { className: classes.mapCardContent, children: _jsx(Typography, { children: "MAP REMOVED PENDING REFACTOR" }) }) }) }))] }) }) }) })) : null;
}
